import {
  CSRF_HEADER_NAME
} from "../chunk-AOSMIDC6.mjs";
import {
  refreshSubpathJWT
} from "../chunk-YUMKHUP4.mjs";

// src/bridge/client.ts
var getBridgeClientFetch = (service, options) => {
  const baseUrl = `/api/bridge/${service}`;
  const defaultHeaders = {
    "Content-Type": "application/json",
    [CSRF_HEADER_NAME]: crypto.randomUUID()
  };
  const refreshJWT = options?.refreshJWT || (() => Promise.resolve());
  const signOut = options?.signOut || (() => Promise.resolve());
  const request = async (input, init = {}, isRetrying = false) => {
    const url = baseUrl + input;
    const headers = { ...defaultHeaders, ...init.headers || {} };
    const response = await fetch(url, {
      ...init,
      headers,
      credentials: "same-origin"
    });
    if (response.status === 401 && !isRetrying) {
      const refreshed = await refreshJWT();
      if (!refreshed) {
        await signOut();
        return response;
      }
      return request(input, init, true);
    }
    if (response.status === 401 && isRetrying) {
      await signOut();
    }
    if (response.status >= 500 && !isRetrying) {
      return request(input, init, true);
    }
    return response;
  };
  return request;
};
var getSubpathBridgeClientFetch = (service) => {
  return getBridgeClientFetch(service, { refreshJWT: refreshSubpathJWT });
};
export {
  getBridgeClientFetch,
  getSubpathBridgeClientFetch
};
//# sourceMappingURL=fetch.mjs.map